<template>
  <v-container fluid>
    <section class="content-header">
      <v-toolbar dark dense color="#96298A">
        <v-toolbar-title>Libreta de Direcciones</v-toolbar-title>
        <v-divider class="mx-4" vertical />
        <v-text-field
          v-model="searcher"
          label="Buscar"
          single-line
          hide-details
          clearable
          max-width="200px"
          @keyup.enter="fillLibretas()"
          @input="handleChangeSearch()"
        ></v-text-field>
        <v-tooltip bottom color="#96298A">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              ref="getData"
              icon
              @click="fillLibretas()"
              x-large
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> mdi-file-find </v-icon>
            </v-btn>
          </template>
          <span>Buscar</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-divider class="mx-4" vertical />
          <v-tooltip bottom color="#96298A">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                @click="fillCbxShowModal()"
                x-large
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-database-plus</v-icon>
              </v-btn>
            </template>
            <span>Crear Nuevo</span>
          </v-tooltip>
          <v-divider class="mx-4" vertical />
          <v-tooltip bottom color="#96298A">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                @click="fillLibretas()"
                x-large
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-table-refresh</v-icon>
              </v-btn>
            </template>
            <span>Actualizar Tabla</span>
          </v-tooltip>
        </v-toolbar-items>
      </v-toolbar>
    </section>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="libretas"
          :search="searcher"
          class="elevation-1"
          :options.sync="options"
          :server-items-length="totalData"
        >
          <template v-slot:item.acciones="{ item }">
            <v-tooltip bottom color="#96298A">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="info"
                  @click="fillCbxShowModal(true, item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom color="#96298A">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="red"
                  @click="deleteItem(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <!--FORMULARIO MODAL -->
    <v-dialog
      v-model="dialog"
      :fullscreen="fullScreen"
      transition="dialog-bottom-transition"
      persistent
      width="800"
    >
      <v-card elevation="24" outlined>
        <v-toolbar dark dense color="#96298A">          
          <v-toolbar-title>Libreta - {{ camposBD.referencia }}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-divider vertical />
            <v-btn v-if="!fullScreen" icon dark @click="fullScreen = true">
              <v-icon>mdi-window-maximize</v-icon>
            </v-btn>            
            <v-btn v-if="fullScreen" icon dark @click="fullScreen = false">
              <v-icon>mdi-window-minimize</v-icon>
            </v-btn>
            <v-divider vertical />
            <v-btn icon dark @click="closeAndResetCbx()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-divider vertical />
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Apodo / Referencia"
                  v-model="camposBD.referencia"
                  ref="cuenta"
                  :rules="[reglas.requeridoTxt, reglas.largo(50)]"
                  :counter="50"
                  required
                  append-icon="check_circle"
                  @change="checkReferencia()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="8">
                <v-alert v-if="referenciaExiste" type="warning"
                  >Esta referencia ya esta registrada</v-alert
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Nombre de la Empresa"
                  v-model="camposBD.empresa"
                  ref="empresa"
                  :rules="[reglas.requeridoTxt, reglas.largo(60)]"
                  required
                  :counter="60"
                  append-icon="domain"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Contacto"
                  v-model="camposBD.contacto"
                  ref="contacto"
                  :rules="[reglas.requeridoTxt, reglas.largo(35)]"
                  required
                  :counter="35"
                  append-icon="person"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Telefono"
                  v-model="camposBD.telefono"
                  ref="telefono"
                  :rules="[reglas.requeridoTxt, reglas.largo(25)]"
                  required
                  :counter="25"
                  append-icon="settings_phone"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="NIT/RUC"
                  v-model="camposBD.nit"
                  ref="nit"
                  :rules="[reglas.largo(20)]"
                  :counter="20"
                  append-icon="card_travel"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="8">
                <v-text-field
                  label="Direccion 1"
                  v-model="camposBD.direccion1"
                  ref="direccion1"
                  append-icon="assistant_direction"
                  :rules="[reglas.requeridoTxt, reglas.largo(45)]"
                  required
                  :counter="45"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  label="Direccion 2"
                  v-model="camposBD.direccion2"
                  ref="direccion2"
                  :rules="[reglas.requeridoTxt, reglas.largo(45)]"
                  :counter="45"
                  required
                  append-icon="assistant_direction"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  label="Direccion 3"
                  v-model="camposBD.direccion3"
                  :rules="[reglas.largo(45)]"
                  :counter="45"
                  ref="direccion3"
                  append-icon="assistant_direction"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Correo"
                  v-model="camposBD.correo"
                  :rules="[reglas.largo(300)]"
                  :counter="300"
                  ref="correo"
                  append-icon="mail"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-combobox
                  v-model="pais"
                  :items="paises"
                  item-text="nombre"
                  item-value="iso"
                  label="Pais"
                  :rules="[reglas.requeridoCbx]"
                  required
                  append-icon="map"
                  return-object
                ></v-combobox>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-combobox
                  v-model="estado"
                  :items="estados"
                  item-text="nombre"
                  item-value="abbr"
                  label="Estado"
                  :rules="[reglas.requeridoCbx]"
                  required
                  append-icon="pin_drop"
                  return-object
                  v-if="camposBD.pais == 'US'"
                ></v-combobox>
                <v-text-field
                  label="Estado / Departamento"
                  v-model="camposBD.estado"
                  ref="estado"
                  :rules="[reglas.largo(35)]"
                  :counter="35"
                  v-if="camposBD.pais != 'US' && camposBD.pais != 'EC'"
                  append-icon="pin_drop"
                ></v-text-field>
                <v-combobox
                  v-model="provincia"
                  :items="provincias"
                  item-text="provincia"
                  item-value="provincia"
                  label="Provincia"
                  :rules="[reglas.requeridoCbx]"
                  required
                  append-icon="pin_drop"
                  return-object
                  v-if="camposBD.pais == 'EC'"
                ></v-combobox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-combobox
                  v-model="ciudad"
                  :items="ciudades"
                  item-text="ciudad"
                  item-value="ciudad"
                  label="Ciudad"
                  :rules="[reglas.requeridoCbx]"
                  required
                  append-icon="pin_drop"
                  return-object
                  v-if="camposBD.pais == 'EC'"
                ></v-combobox>
                <v-text-field
                  label="Ciudad"
                  v-model="camposBD.ciudad"
                  ref="ciudad"
                  :rules="[reglas.requeridoTxt, reglas.largo(35)]"
                  :counter="35"
                  required
                  append-icon="place"
                  v-if="camposBD.pais != 'EC'"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="ZIP"
                  v-model="camposBD.zip"
                  :rules="[reglas.largo(12)]"
                  :counter="12"
                  ref="zip"
                  append-icon="near_me"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error darken-1" outlined @click="closeAndResetCbx()">
            Cancelar
            <v-icon dark>mdi-close</v-icon>
          </v-btn>
          <v-btn color="primary darken-1" outlined @click="saveItem()">
            Guardar
            <v-icon dark>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--FORMULARIO MODAL -->
  </v-container>
</template>
<script>
import apicon from "../plugins/apicon";
export default {
  created: function () {},
  data() {
    return {
      fullScreen: false,
      searcher: "",
      options: {},
      totalData: 0,
      dialog: false,
      valid: true,
      modalEditando: false,
      isCliente: 1,
      libretas: [],
      paises: [],
      pais: null,
      estados: [],
      estado: null,
      provincias: [],
      provincia: null,
      ciudades: [],
      ciudad: null,
      referenciaExiste: false,
      headers: [
        { text: "Referencia", value: "referencia" },
        { text: "Contacto", value: "contacto" },
        { text: "Empresa", value: "empresa" },
        { text: "Telefono", value: "telefono" },
        { text: "Direccion 1", value: "direccion1" },
        { text: "Direccion 2", value: "direccion2" },
        { text: "Ciudad", value: "ciudad" },
        { text: "Pais", value: "pais" },
        { text: "Acciones", align: "end", value: "acciones", sortable: false },
      ],
      /*Variables*/
      camposBD: {
        id: 0,
        cuenta: null,
        referencia: null,
        contacto: null,
        empresa: null,
        nit: null,
        telefono: null,
        direccion1: null,
        direccion2: null,
        direccion3: null,
        correo: null,
        ciudad: null,
        provincia: null,
        estado: null,
        zip: null,
        pais: null,
        id_usuario: null,
      },
      /*Variables*/
    };
  },
  watch: {
    pais: function (item) {
      if (item) {
        this.camposBD.pais = item.iso;  
        if(item.iso != 'EC') {
          this.provincia = null;
          this.ciudad = null;
          this.camposBD.provincia = null;          
        }        
      }
    },
    estado: function (item) {
      if (item) {
        this.camposBD.estado = item.abbr;
      }
    },
    provincia: function (item) {
      if (item) {
        this.camposBD.provincia = item.provincia;
        this.ciudad = null;
        this.fillCiudadesEc(item.provincia);
      }
    },
    ciudad: function (item) {
      if (item) {
        this.camposBD.ciudad = item.ciudad;
      }
    },
    options: {
      handler() {
        this.fillLibretas();
      },
      deep: true,
    },
  },
  methods: {
    //Obtener los datos para rellenar la tabla del index
    fillLibretas: function () {
      const { page, itemsPerPage } = this.options;
      apicon
        .getDataApi(
          apicon.getApiBaseUrl() +
            "libreta?page=" +
            page +
            "&per_page=" +
            itemsPerPage +
            (this.searcher != null ? "&search=" + this.searcher : "")
        )
        .then((result) => {
          this.libretas = result.data;
          this.totalData = result.total;
        });
    },
    fillPaises:async function () {
      await apicon.getDataApi(apicon.getApiBaseUrl() + "pais").then((result) => {
        this.paises = result;
      });
    },
    fillEstados:async function () {
      await apicon.getDataApi(apicon.getApiBaseUrl() + "estado").then((result) => {
        this.estados = result;
      });
    },
    fillProvincias: async function () {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "provinciasec")
        .then((result) => {
          this.provincias = result;
        });
    },
    fillCiudadesEc:async function (provincia) {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "ciudadesec/" + provincia)
        .then((result) => {
          this.ciudades = result;
        });
    },
    //Guardar o Actualizar
    saveItem: function () {
      if (this.$refs.form.validate()) {
        //Actualizar
        if (this.modalEditando) {
          apicon.updateDataApi(
            apicon.getApiBaseUrl() + "libreta/" + this.camposBD.id,
            this.camposBD
          ).then((result) => {
            this.fillLibretas();
            this.closeAndResetCbx();
            this.$swal(result.message);
          });
        } else {
          //Guardar
          apicon
            .saveDataApi(apicon.getApiBaseUrl() + "libreta", this.camposBD)
            .then((result) => {
              this.fillLibretas();
              this.limpiarCampos();
              this.pais = null;
              this.$swal(result.message);
            });
        }
      }
    },
    //Eliminar
    deleteItem: function (item) {
      var self = this;
      this.$swal(this.dswalEliminar).then((resultdlg) => {
        if (resultdlg.value) {
          apicon
            .deleteDataApi(apicon.getApiBaseUrl() + "libreta/" + item.id)
            .then((result) => {
              self.fillLibretas();
              this.$swal(result.message);
            });
        }
      });
    },
    fillCbxShowModal: async function (editando = false, item = []) {
      this.modalEditando = editando;
      await this.fillPaises();
      await this.fillEstados();
      await this.fillProvincias();

      if (editando) {
        await Object.keys(this.camposBD).forEach((key) => {
          this.camposBD[key] = item[key];
        });
        this.pais = item.pais_data;
        this.estado = item.estado_data;
        this.provincia = this.provincias.find((pro) => pro.provincia === item.provincia);
        await this.fillCiudadesEc(this.provincia != null ? this.provincia.provincia : 0);
        this.ciudad = this.ciudades.find((ciu) => ciu.ciudad === item.ciudad);
      } else {
        this.limpiarCampos();
      }
      this.dialog = true;
    },
    limpiarCampos: function () {
      Object.keys(this.camposBD).forEach((key) => {
        this.camposBD[key] = null;
      });
      this.pais = null;
      this.estado = null;
      this.provincia = null;
      this.ciudad = null;
      this.referenciaExiste = false;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    closeAndResetCbx: function () {
      this.limpiarCampos();
      this.dialog = false;
    },
    handleChangeSearch: function () {
      if (this.searcher == null || this.searcher == "") {
        this.fillLibretas();
      }
    },
    checkReferencia: function () {
      if (this.camposBD.referencia != null) {
        apicon
          .getDataApi(
            apicon.getApiBaseUrl() + "verificarref/" + this.camposBD.referencia
          )
          .then((result) => {
            if (result.status) {
              this.referenciaExiste = true;
            } else {
              this.referenciaExiste = false;
            }
          });
      } else {
        this.referenciaExiste = false;
      }
    },
  },
  mounted() {
    apicon.setAuthHeaders();
    this.isCliente = localStorage.getItem("cliente");
  },
};
</script>